import React from "react";
import "./GlamurPaintFeatures.css";

const featuresData = [
  {
    title: "Climate-Optimized Formulations:",
    description:
      "Each product is specifically formulated considering Pakistan's unique climate challenges, from coastal humidity in Karachi to extreme temperatures in interior regions.",
  },
  {
    title: "Superior Coverage:",
    description:
      "Our paints provide excellent hiding power, reducing the number of coats required and saving both time and money for customers across Pakistan.",
  },
  {
    title: "Long-Lasting Performance:",
    description:
      "Rigorous quality control ensures our paints maintain color brilliance and protective properties longer than many competing paint brands in Pakistan.",
  },
  {
    title: "Versatile Applications:",
    description:
      "Whether you're painting a small room in Karachi or a large commercial project in Sindh Province, our product range covers all requirements.",
  },
  {
    title: "Professional Results:",
    description:
      "Designed to deliver professional-quality results whether applied by experienced contractors or DIY homeowners throughout Pakistan.",
  },
];

const GlamurPaintFeatures = () => {
  return (
    <div className="glamur-features-section">
      <h2 className="glamur-features-heading">
        Why Glamur Paint Products Excel
      </h2>
      <div className="glamur-features-container">
        {featuresData.map((feature, index) => (
          <div key={index} className="feature-card">
            <h3 className="card-title">{feature.title}</h3>
            <p className="card-description">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GlamurPaintFeatures;
